/**
 * Hop duck mark (lowercase h with duck cutout).
 * Filled currentColor so it tints like other workspace icons.
 * Source: frontend/public/icons/hop-duck.svg (traced from Hop mark).
 */

import { forwardRef } from 'react'
import type { LucideProps } from 'lucide-react'
import { cn } from '@/lib/utils'

export const RubberDuckIcon = forwardRef<SVGSVGElement, LucideProps>(function RubberDuckIcon(
  { className, size = 24, color = 'currentColor', strokeWidth: _strokeWidth, absoluteStrokeWidth: _absoluteStrokeWidth, ...props },
  ref,
) {
  const dimension = typeof size === 'number' ? size : 24

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={dimension}
      height={dimension}
      fill={color}
      stroke="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden
      {...props}
    >
      <path d="M6.86 1.74a3 3 0 0 0-.9.32c-.27.14-.6.4-.57.45q.02.04 0 .01c-.03-.02-.32.24-.32.3q-.01.04-.08.11c-.14.14-.38.68-.46 1.03l-.07.34v7.76c0 7.68 0 7.76.06 8.07a2.9 2.9 0 0 0 2.04 2.18c.28.1.37.1.73.1.33 0 .47-.02.78-.1.41-.1.87-.3.84-.36q-.01-.03.02-.01c.05.04.36-.19.6-.44a3 3 0 0 0 .79-1.86c0-.27-.2-.85-.33-.98-.21-.2-.62-.7-.8-1a5 5 0 0 1-.52-1c-.09-.27-.1-.3-.1-.84 0-.52.02-.58.1-.85.18-.52.39-.89.7-1.2.56-.6 1.59-.93 2.52-.84.5.06 1.15.27 1.42.46q.08.06.13.04.03 0 .05.03l.15.14c.23.14.48.4.63.63s.4.69.41.78c.03.15.18.52.24.55a5 5 0 0 0 1.82.45c.21.02.24.03.3.13.12.2.04.58-.15.73q-.05.04-.04.08t-.02.01c-.02-.01-.1.02-.16.08-.23.19-.85.35-1.77.46-.65.08-.64.08-.8.29q-.37.47-.43.91c-.05.35 0 .95.1 1.43.18.88.4 1.25.96 1.68a3 3 0 0 0 2.9.52l.18-.08c.7-.27 1.33-.98 1.59-1.78.13-.43.14-.8.13-3.66-.02-2.8-.03-2.95-.18-3.7a5 5 0 0 0-.54-1.59c.03-.04-.17-.38-.2-.35q-.03.02 0-.02c.02-.03-.14-.28-.34-.54a6 6 0 0 0-.77-.76 4 4 0 0 0-.99-.62 8 8 0 0 0-3.72-.74 7 7 0 0 0-1.91.2c-.2.04-.41.1-.47.1l-.09.02V6.6c0-2.4-.01-2.56-.19-3.04a2.95 2.95 0 0 0-3.27-1.82" />
    </svg>
  )
})

RubberDuckIcon.displayName = 'RubberDuckIcon'
